import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ActeeModalComponent, Notification } from '@fnccr-actee/design-system';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ActeeModalComponent, Notification],
  templateUrl: './app.html',
  styleUrl: './app.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
